var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import Vue from 'vue';
import VueChart from 'vue-chart-js';
import Buefy from 'buefy';
import firebase from 'firebase';
import VueFire from 'vuefire';
import moment from 'moment';
import App from '@/App.vue';
import router from '@/router/index';
import { db } from '@/services/firebase';
import { apolloHandler } from '@/services/apollo';
import { UserAuth } from '@/services/user';
Vue.use(VueChart);
Vue.use(Buefy);
Vue.use(VueFire);
Vue.filter('date', function (value) {
    return moment(value).format('MM/DD/YYYY');
});
Vue.filter('decimal', function (value) {
    if (isNaN(value)) {
        return '--';
    }
    return Math.floor(value * 100) / 100 + "'";
});
Vue.filter('decimal-alt', function (value) {
    if (isNaN(value)) {
        return '--';
    }
    var newValue = Math.floor(value * 100) / 100;
    return newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});
Vue.filter('no-decimal', function (value) {
    if (!value) {
        return '--';
    }
    var returnNum = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0];
    return returnNum + " lbs";
});
Vue.filter('available', function (value) {
    if (!value) {
        return '';
    }
    if (value.capacity && value.current_weight) {
        var capacity = parseInt(value.capacity.toString());
        var current_weight = parseInt(value.current_weight.toString());
        if (!isNaN(capacity) && !isNaN(current_weight)) {
            return capacity - current_weight;
        }
        else {
            return '';
        }
    }
    else {
        return '';
    }
});
Vue.filter('percentage', function (value) {
    if (!value) {
        return '';
    }
    var percentage = parseFloat(value.toString());
    if (!isNaN(percentage)) {
        percentage = percentage * 100;
        return Math.floor(percentage * 100) / 100;
    }
    else {
        return '';
    }
});
Vue.config.productionTip = false;
var app;
var auth = new UserAuth();
var apolloProvider = apolloHandler.createProvider();
if (db) {
    firebase.auth().onAuthStateChanged(function (user) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!user) return [3 /*break*/, 2];
                    return [4 /*yield*/, auth.startPoll()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    auth.stopAndClearToken();
                    _a.label = 3;
                case 3:
                    if (!app) {
                        app = new Vue({
                            el: '#app',
                            router: router,
                            apolloProvider: apolloProvider,
                            template: '<App/>',
                            components: { App: App, VueChart: VueChart }
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); });
}



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 792
// module chunks = 1